import { CertNaming } from "@ndn/keychain";
import { NameMap, NameMultiMap } from "@ndn/packet";
/** A container of trust anchors. */
export class TrustAnchorContainer {
    byCertName = new NameMap();
    byKeyName = new NameMultiMap();
    /**
     * Constructor.
     * @param certs - Trust anchors.
     */
    constructor(certs = []) {
        for (const cert of certs) {
            this.add(cert);
        }
    }
    /** Add a certificate as a trust anchor. */
    add(cert) {
        if (this.byCertName.has(cert.name)) {
            return;
        }
        this.byCertName.set(cert.name, cert);
        this.byKeyName.add(CertNaming.toKeyName(cert.name), cert);
    }
    /** Remove a trust anchor. */
    remove(cert) {
        this.byCertName.delete(cert.name);
        this.byKeyName.remove(CertNaming.toKeyName(cert.name), cert);
    }
    /** Determine if a certificate has been added as a trust anchor. */
    has(cert) {
        return this.byCertName.has(cert.name);
    }
    /** Find trust anchors by certificate name or key name. */
    async *findCerts(keyLocator) {
        if (CertNaming.isCertName(keyLocator)) {
            const cert = this.byCertName.get(keyLocator);
            if (cert) {
                yield cert;
            }
        }
        else {
            yield* this.byKeyName.list(keyLocator);
        }
    }
}
